import { styled } from '@mui/material/styles';
import type { ReactNode } from 'react';
import { createPortal } from 'react-dom';
import type { BaseTourStop, TourContextInterface } from './tourContextBase';

const Overlay = styled('div')`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999;
  pointer-events: auto;
`;

interface TourOverlayProps<TStop extends BaseTourStop, T extends HTMLElement> {
  useTourHook: () => TourContextInterface<TStop, T> | null;
  children?: ReactNode;
}

export function TourOverlay<TStop extends BaseTourStop, T extends HTMLElement>({
  useTourHook,
  children,
}: TourOverlayProps<TStop, T>) {
  const context = useTourHook();

  if (!context) {
    return <>{children}</>;
  }

  const { hasCompletedTour, currentStop } = context;

  const showOverlay = !hasCompletedTour && currentStop;

  return (
    <>
      {showOverlay && createPortal(<Overlay />, document.body)}
      {children}
    </>
  );
}
